'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTilePromoCode = renderWithRef('StandardTilePromoCode', null, (e, d)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: d,
        classNames: [
            'swan-standard-tile-promo-code'
        ],
        props: e,
        children: e.children
    }));

export { StandardTilePromoCode };
